module.exports = __webpack_public_path__ + "img/gift_jbl_tt_cx.c38a7042.jpg";